'use strict';

angular.module('TurneroApp').component('coTramites', {
    bindings: {
        ctrlAdmin: '='
    },
    controller: [
        'tramitesService',
        'utilsService',
        'TurneroAppConstant',
        '$element',
        function (tramitesService, utilsService, TurneroAppConstant, $element) {
            var ctrl = this;

            ctrl.tramiteCrear = false;
            ctrl.tramiteModificar = false;
            ctrl.tramiteConsultar = true;
            ctrl.tramiteVer = false;
            ctrl.tramites = {};
            ctrl.focusBuscar = false;
            ctrl.permisos = TurneroAppConstant.Permisos;

            //GENERAL
            ctrl.limitOptions = [10, 25, 50, 75, 100, {
                label: 'Todos',
                value: function () {
                    return ctrl.pagination.total;
                }
            }];

            ctrl.query = {
                limit: 10,
                page: 1,
                filter: ''
            };

            //Se inicializa en null para que al principio no tome que no hay valores
            ctrl.pagination = {
                total: null
            };

            ctrl.filter = false;

            ctrl.$onChanges = function () {
                ctrl.grillaReload();
            };

            ctrl.limpiarMemoria = function () {
                ctrl.tramites = {};
                ctrl.tramiteCrear = false;
                ctrl.tramiteModificar = false;
                ctrl.tramiteConsultar = false;
                ctrl.tramiteVer = false;
            }

            ctrl.removeFilter = function () {
                ctrl.query.filter = '';
                ctrl.grillaReload();
                ctrl.filter = false;
            };

            ctrl.mostrarBuscar = function () {
                ctrl.filter = true;
                ctrl.focusBuscar = true;
            };

            ctrl.grillaReload = function () {
                ctrl.limpiarMemoria();
                ctrl.tramiteConsultar = true;

                if (ctrl.query.filter.length > 2 || ctrl.query.filter.length == 0) {
                    ctrl.getData(ctrl.query.page, ctrl.query.limit, 'grid', cargarDatos)
                }
            };

            ctrl.getData = function (page, limit, tipo, callback) {

                ctrl.promise = tramitesService.getfiltro({
                    'filtro.Nro_Pagina': page,
                    'filtro.Tam_Pagina': limit,
                    'filtro.Texto': ctrl.query.filter
                }).$promise.then(function (data) {
                    callback(tipo, data);
                }).catch(function (error) {
                    utilsService.errores(error)
                });

            }

            function cargarDatos(tipo, data) {
                if (tipo == 'grid') {
                    ctrl.tramites = data.Data;
                    ctrl.pagination.total = data.Reg_Totales;
                } else if (tipo == 'xls') {
                    var arrayObject = data.Data;
                    ctrl.arrayExport = [];
                    ctrl.arrayExport[0] = ['Id', 'Nombre', 'Id Ref Guia de Tramites Municipal','Tiene Restriccion'];
                    for (var i = 0; i < arrayObject.length; i++) {
                        ctrl.arrayExport[i + 1] = [
                            arrayObject[i].IdTramite,
                            arrayObject[i].NTramite,
                            arrayObject[i].IdRefGuiaTramitesMunicipal,
                            arrayObject[i].TieneRestriccion ? "SI" : "NO",

                        ]
                    }
                    swal.close();
                    ctrl.Excel.down([{
                        name: 'Trámites',
                        data: ctrl.arrayExport
                    }]);
                }
            }

            //ALTA
            ctrl.LoadAlta = function () {
                ctrl.limpiarMemoria();
                ctrl.tramiteCrear = true;
                ctrl.tLoadAlta();
            };

            //MODIFICAR
            ctrl.modificarTramite = function (item) {
                ctrl.limpiarMemoria();
                ctrl.tramiteModificar = true;
                ctrl.tLoadModificar(item);
            };

            //VER
            ctrl.verTramite = function (item) {
                ctrl.limpiarMemoria();
                ctrl.tramiteVer = true;
                ctrl.tLoadModificar(item);
            };

            //BAJA
            ctrl.eliminarTramite = function (item) {
                swal({
                    title: "Eliminar Trámite",
                    text: "¿Desea eliminar el trámite?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#e77a1e",
                    confirmButtonText: "Si, eliminarlo!",
                    cancelButtonText: "No, cancelar!",
                    allowEscapeKey: false,
                    allowOutsideClick: false
                }).then(function () {
                    tramitesService.delete({ 'id': item.IdTramite }).$promise.then(function () {
                        ctrl.grillaReload();
                        swal("Eliminado!", "El trámite ha sido eliminado correctamente.", "success");
                    }).catch(function (error) {
                        utilsService.errores(error);
                    });
                });
            };

            //EXPORTAR A EXCEL
            ctrl.isOpen = false;
            ctrl.selectedMode = 'md-fling';
            ctrl.selectedDirection = 'up';
            ctrl.exportar = function (tipo) {
                utilsService.swalTitle('Exportando datos', 'info')
                ctrl.arrayExport = [];
                ctrl.getData(1, ctrl.pagination.total, tipo, cargarDatos)

            }
            ctrl.Excel = {
                down: function () {
                },
            }

            $element.find('input').on('keydown', function (ev) {
                ctrl.searchTerm = ctrl.searchTerm
                ev.stopPropagation();
            });

            //SUBIR RESTRICCION
            ctrl.subirRestriccion = function (item) {
                swal({
                    title: "Subir Restricción",
                    html: "Atención! Una vez subido el archivo de restricción se remplazaran los datos anteriores.<br><br>Subir un archivo formato CSV, de una columna, en la primera celda escriba <strong>Cuil</strong>, luego cada celda debe contener el número de cuil sin guiones ni puntos.",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Subir Restricción",
                    cancelButtonText: "Cancelar",
                    cancelButtonColor: "#e77a1e",
                    allowEscapeKey: false,
                    allowOutsideClick: false
                }).then(function () {
                    var inputFile = document.createElement('input');
                    inputFile.type = 'file';
                    inputFile.style.display = 'none';
                    document.body.appendChild(inputFile);
                    inputFile.click();
                
                    inputFile.onchange = function (event) {
                    var file = event.target.files[0];
                      if (file) {
                        var formData = new FormData();
                        formData.append('restriccionFile', file);
                        tramitesService.putRestriccion({ id: item.IdTramite }, formData).$promise.then(function () {
                          ctrl.grillaReload();
                          swal("Subido!", "La restricción ha sido subida correctamente.", "success");
                        }).catch(function (error) {
                          utilsService.errores(error);
                        });
                      }
                      document.body.removeChild(inputFile);
                    };
                });
            };
            

            //BORRAR RESTRICCION
            ctrl.borrarRestriccion = function (item) {
                swal({
                    title: "Eliminar Restricción",
                    text: "¿Desea eliminar la restricción? Si lo haces, este cambio sera irreversible",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#e77a1e",
                    confirmButtonText: "Si, eliminarlo!",
                    cancelButtonText: "No, cancelar!",
                    allowEscapeKey: false,
                    allowOutsideClick: false
                }).then(function () {
                    tramitesService.deleteRestriccion({ 'id': item.IdTramite }).$promise.then(function () {
                        ctrl.grillaReload();
                        swal("Eliminado!", "La restricción ha sido eliminado correctamente.", "success");
                    }).catch(function (error) {
                        utilsService.errores(error);
                    });
                });
            };

        }
    ],
    template: require('./tramites.html')
});



// WEBPACK FOOTER //
// ./app/components/tramites/tramitesComponent.js